// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"422":"a72f5318","484":"2a8c9626","551":"3a603445","828":"3ca3abfd"}[chunkId] + ".chunk.js";
};